import { MAX_SEED_LENGTH, PublicKey } from "@solana/web3.js";
import { BlobField } from "./BlobField";
export class PublicKeyField extends BlobField {
    constructor(property) {
        super(MAX_SEED_LENGTH, property);
    }
    fromBuffer(buffer) {
        return this.fromPublicKey(new PublicKey(buffer));
    }
}
//# sourceMappingURL=PublicKeyField.js.map